/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React from "react";
import { PenLine, Link2, ShieldCheck, Hourglass, FileDown } from "lucide-react";
import { toast } from "../../../../components/ui/sonner";
import { authStore } from "../../../../lib/api";
import { T } from "../../../../lib/i18n";
import { Auto, Who, Card, Pill, dt } from "./PreFlow";
import FileUploadDate from "../FileUploadDate";

export const SignoffPanel = ({ pre }) => {
  const so = pre.ownerSignoff || {};
  const sch = pre.schematic || {};
  const sig = (pre.signatures || [])[0];
  const signed = !!so.signedAt || !!sig;
  return (
    <>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <Auto>{T("客户确认自动派单 · 签字自动完成")}</Auto>
        <Who d={pre.designers.us} label="负责 · 美国建筑设计师" tid="dv3-pre-so-who" />
        {signed ? <Pill ok tid="dv3-pre-so-status">{T("业主已签字 {0}", [dt(so.signedAt || sig?.at)])}</Pill> : sch.clientConfirmedAt ? <Pill warn tid="dv3-pre-so-status">{T("客户已确认方案 · 等待在线签字")}</Pill> : <Pill tid="dv3-pre-so-status">{T("等待客户确认方案")}</Pill>}
      </div>
      <Card title={T("Owner 在线签字")} icon={PenLine} tid="dv3-pre-so-card">
        {signed ? (
          <div className="text-[11px] text-slate-600 space-y-0.5" data-testid="dv3-pre-so-receipt">
            <p className="inline-flex items-center gap-1 text-emerald-700 font-semibold"><ShieldCheck className="h-3.5 w-3.5" />{T("已签署 · 本步骤已自动完成并推进下一阶段")}</p>
            <p>{T("签署人")} <b className="text-slate-800">{so.signerName || sig?.signerName}</b> · {dt(so.signedAt || sig?.at)} · v{so.fileVersion || sig?.fileVersion}</p>
            {sig?.recordHash && <p className="font-mono text-[9px] text-slate-400 break-all">{T("存证")} {sig.recordHash}</p>}
            {sig?.signedPdf?.fileId && <p className="flex flex-wrap items-center gap-x-1"><a href={`${process.env.REACT_APP_BACKEND_URL}/api/files/${sig.signedPdf.fileId}/download?auth=${encodeURIComponent(authStore.get("ali_token") || "")}`} target="_blank" rel="noreferrer" data-testid="dv3-pre-so-signed-pdf" className="inline-flex items-center gap-1 text-violet-700 hover:underline"><FileDown className="h-3 w-3" />{T("签字确认书 PDF（原图纸 + 证书页 · 已同步销售）")}</a><FileUploadDate value={sig.signedPdf.uploadedAt} /></p>}
          </div>
        ) : (
          <div className="text-[11px] text-slate-600 space-y-1">
            <p className="inline-flex items-center gap-1"><Hourglass className="h-3.5 w-3.5 text-amber-500" />{T("业主在门户点击「确认并签署」后，系统自动完成本任务、关闭阶段并通知设计师，无需手动操作。")}</p>
            {sch.reviewUrl && <p className="flex items-center gap-1"><Link2 className="h-3 w-3 text-slate-400" /><a href={sch.reviewUrl} target="_blank" rel="noreferrer" className="text-violet-700 hover:underline truncate max-w-[300px]" data-testid="dv3-pre-so-link">{sch.reviewUrl}</a><button type="button" onClick={() => navigator.clipboard?.writeText(sch.reviewUrl).then(() => toast.success(T("已复制")))} className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 text-[10px] text-slate-400 hover:text-violet-700" data-testid="dv3-pre-so-copy">{T("复制发给业主")}</button></p>}
            {!sch.reviewUrl && <p className="text-slate-400">{T("请先在「Site Plan + Floor Plan 方案」阶段发送客户审阅链接。")}</p>}
          </div>
        )}
      </Card>
    </>
  );
};
